import { render, staticRenderFns } from "./DetailsTicketButton.vue?vue&type=template&id=f45e2828&scoped=true"
import script from "./DetailsTicketButton.vue?vue&type=script&lang=ts"
export * from "./DetailsTicketButton.vue?vue&type=script&lang=ts"
import style0 from "./DetailsTicketButton.vue?vue&type=style&index=0&id=f45e2828&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f45e2828",
  null
  
)

export default component.exports